import type { useI18nContext } from "@procore/core-react";
import { object, date, array, string } from "yup";
import { CONTENT_MAX_LENGTH } from "@/react/components/common/constants/communications";

export const bulkSendMessageSchema = (
   I18n: ReturnType<typeof useI18nContext>,
   shouldScheduleDelivery: boolean,
) => {
   const contentValidation = string()
      .trim()
      .required(I18n.t("views.company.workforce_planning.validations.required_field"))
      .min(1, I18n.t("views.company.workforce_planning.validations.required_field"))
      .max(
         CONTENT_MAX_LENGTH,
         I18n.t("views.company.workforce_planning.communications.character_limit_reached"),
      );

   if (!shouldScheduleDelivery) {
      return object().shape({
         recipients: array()
            .required(I18n.t("views.company.workforce_planning.validations.required_field"))
            .min(1, I18n.t("views.company.workforce_planning.validations.required_field")),
         subject: string()
            .trim()
            .required(I18n.t("views.company.workforce_planning.validations.required_field"))
            .min(1, I18n.t("views.company.workforce_planning.validations.required_field")),
         content: contentValidation,
      });
   }

   return object().shape({
      recipients: array()
         .required(I18n.t("views.company.workforce_planning.validations.required_field"))
         .min(1, I18n.t("views.company.workforce_planning.validations.required_field")),
      subject: string()
         .trim()
         .required(I18n.t("views.company.workforce_planning.validations.required_field"))
         .min(1, I18n.t("views.company.workforce_planning.validations.required_field")),
      content: contentValidation,
      scheduled_day: date().required(
         I18n.t("views.company.workforce_planning.validations.required_field"),
      ),
      hour: object().required(
         I18n.t("views.company.workforce_planning.validations.required_field"),
      ),
      minute: object().required(
         I18n.t("views.company.workforce_planning.validations.required_field"),
      ),
      day_night: object().required(
         I18n.t("views.company.workforce_planning.validations.required_field"),
      ),
   });
};
